import styled from 'styled-components'

import { _L_Medium, _M_Normal, mainColors, zIndex } from '../../styles'
import { Modal } from '../Modal'

export const StyledModal = styled(Modal)`
  div[class*='CardStyled'] {
    position: relative;
    width: 400px;
    display: flex;
    flex-direction: column;
    padding: 30px;
  }

  div[class*='Close'] {
    position: absolute;
    top: 16px;
    right: 24px;
    z-index: ${zIndex.PORTAL};
  }

  svg[class*='Close'] {
    right: 0;
    top: 0;
    color: ${mainColors.neutralExtraDark};
  }
`

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const ModalConfirmation = styled.span`
  ${_L_Medium};
  color: ${mainColors.primaryDark};
  text-align: left;
  margin-top: 16px;
`

export const Text = styled.p`
  margin-top: 16px;
  ${_M_Normal};
  text-align: left;
  color: ${mainColors.neutralExtremelyDark};
`

export const ButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 26px;
  width: 100%;
`
